import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import submittingRequestStatus from "./submittingRequestStatusAction";
import * as API from "../utils/apiPath";
import { renderGlobalModal } from "../utils/helpers";

export function loadCategoryDataSuccess(categories) {
  return { type: types.LOAD_CATEGORY_DATA_SUCCESS, categories };
}

export function loadReportCategoryDataSuccess(reportcategories) {
  return { type: types.LOAD_REPORT_CATEGORY_DATA_SUCCESS, reportcategories };
}

export function loadForumDataSuccess(forums) {
  return { type: types.LOAD_FORUM_DATA_SUCCESS, forums };
}

export function loadForumUserDataSuccess(forumusers) {
  return { type: types.LOAD_FORUM_USER_DATA_SUCCESS, forumusers };
}
export function loadReportCategoryDataUserSuccess(categoriesUser) {
  return {
    type: types.LOAD_REPORT_CATEGORY_DATA_USER_SUCCESS,
    categoriesUser,
  };
}

export function loadCategoryData() {
  return async function (dispatch) {
    await agent
      .get(API.FORUM_CATEGORY, {})
      .then((response) => {
        dispatch(loadCategoryDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadForumData(id) {
  return async function (dispatch) {
    await agent
      .get(API.FORUM_DATA_FETCH + "/" + id, {})
      .then((response) => {
        dispatch(loadForumDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}


export function saveForumQuestion(params, props, setLoader) {
  return async function (dispatch) {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_QUESTION, params);

      dispatch(loadForumDataSuccess(response.data.data));

      return { success: true, message: response.data.message }; // <<< return message
    } catch (error) {
      setLoader(false);

      if (error?.status === 422) {
        return { success: false, message: error.message };
      }

      return { success: false, message: "Something went wrong!" };
    }
  };
}

export function saveForumUser(id) {
  return async function (dispatch) {
    await agent
      .post(API.FORUM_USER_SET, id)
      .then((response) => {
        dispatch(submittingRequestStatus(false));
      })
      .catch((error) => {
        dispatch(submittingRequestStatus(false));
        throw error;
      });
  };
}

export function loadForumUserData(user_role) {
  return async function (dispatch) {
    await agent
      .get(API.FORUM_USER_GET + "/" + user_role, {})
      .then((response) => {
        dispatch(loadForumUserDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}



export function saveForumAnswer(params, props) {
  return async function (dispatch) {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_ANSWER, params);
      dispatch(loadForumDataSuccess(response.data.data));

      return { success: true, message: response.data.message }; // <<< return message
    } catch (error) {

      if (error?.status === 422) {
        return { success: false, message: error.message };
      }

      return { success: false, message: "Something went wrong!" };
    }
  };
}


export function saveForumAnswerLike(params) {
  return async function (dispatch) {
    try {
      const response = await agent.post(API.FORUM_ANS_LIKE_SET, params);
      renderGlobalModal({
        message: response.message,
      });
      dispatch(loadForumDataSuccess(response?.data?.data));


    } catch (error) {

      renderGlobalModal({
        message: error.message,
      });
    }
  };
}


export function loadReportCategoryData() {
  return async function (dispatch) {
    await agent
      .get(API.FORUM_REPORT_CATEGORY, {})
      .then((response) => {
        dispatch(loadReportCategoryDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadReportCategoryDataUser() {
  return async function (dispatch) {
    await agent
      .get(API.FORUM_REPORT_CATEGORY_USER, {})
      .then((response) => {
        dispatch(loadReportCategoryDataUserSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}



export function saveForumReportAdmin(params, props, setLoader) {
  return async function (dispatch) {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_REPORT_ADMIN, params);


      return {
        success: true,
        message: response?.data?.message || "",
        updatedData: response?.data?.data,
      };

    } catch (error) {

      return {
        success: false,
        message: error?.message || "Something went wrong.",
      };
    }
  };
}



export function saveForumReportUser(params, props, setLoader) {
  return async function (dispatch) {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_REPORT_USER, params);

      return { success: true, message: response.data.message };
    } catch (error) {
      setLoader(false);

      if (error.status === 422) {
        return { success: false, message: error.message };
      }

      return { success: false, message: "Something went wrong" };
    }
  };
}

